import { ErrorBoundary } from "react-error-boundary"
import useLocationData from "../../hooks/use-location-data"
import type { FieldProps } from "../../types/form-types"
import { SelectField } from "./select"
import { Suspense, useEffect, useMemo } from "react"
// import { Loader2 } from "lucide-react"
import { useFormStore } from "@/stores/use-form-store"
import { Spinner } from "../ui/spinner"

export const Country = ({ form, field, commonAttributes }: FieldProps) => {
	const { useCountries } = useLocationData()
	const { data: countries } = useCountries()
	const { submissionValues, verifiedFields } = useFormStore()

	const options = useMemo(() => {
		return countries
			.sort((a, b) => a.name.localeCompare(b.name))
			.map(country => ({
				label: country.name,
				value: country.name,
			}))
	}, [countries])

	useEffect(() => {
		if (submissionValues && submissionValues[field.field_id]) {
			const value = submissionValues[field.field_id]
			if (value != "") form.setValue(field.field_id, value)
		}
	}, [options, submissionValues])

	return (
		<SelectField
			field={field}
			form={form}
			commonAttributes={commonAttributes}
			optionsPreSet={options}
			isDisabled={verifiedFields.has(field.field_id)}
		/>
	)
}

export const CountryField = (props: FieldProps) => {
	return (
		<ErrorBoundary
			fallback={<div>Something went wrong</div>}
			resetKeys={[window.location.pathname, window.location.search]}
		>
			<Suspense
				fallback={
					<div className="flex h-full items-center justify-center">
						<Spinner />
					</div>
				}
			>
				<Country {...props} />
			</Suspense>
		</ErrorBoundary>
	)
}
